import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../layout/components/content-header/content-header.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService } from "../../../auth/service";
import { Router } from "@angular/router";
import { ListService } from "../../../auth/service/list.service";
import { locale as italian } from "../../../i18n/it";
interface ICausal {
  name: string;
  id?: number;
  other: { code: string };
}

@Component({
  selector: "app-causal",
  templateUrl: "./causal-list.component.html",
  styleUrls: ["./causal-list.component.scss"],
})
export class CausalListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public causal: ICausal = {
    name: null,
    other: { code: null },
  };
  public causalList: ICausal[] = [];
  public filteredCausalList: ICausal[] = [];
  public showModalError: boolean = false;

  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _listService: ListService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.CAUSALS,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.CAUSALS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_causal_list")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadCausal();
  }

  async loadCausal() {
    this.causalList = await this._listService.getList("causal");
    this.causalFilter();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  causalFilter() {
    let items: ICausal[] = this.causalList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.causalList.filter((item: ICausal) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()) || item.other.code.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    this.filteredCausalList = items;
  }

  public modalOpen(whichModal, causal: ICausal) {
    this.showModalError = false;
    this.causal = {
      name: null,
      other: { code: null },
    };
    if (!!causal) {
      this.causal = {
        id: causal.id,
        name: causal.name,
        other: {
          code: causal.other.code,
        },
      };
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
  }

  isError(): boolean {
    if (!this.causal.name || this.causal.name.trim() === "" || this.causal.name.length < 1 || !this.causal.other.code || this.causal.name.trim() === "" || this.causal.name.length < 1) {
      this.showModalError = true;
      return true;
    }
  }

  async deleteCausal(currentCausal: ICausal) {
    if (!this._authenticationService.hasCapability("delete_causal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentCausal.name;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._listService
          .delete(currentCausal.id, "causal")
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.loadCausal();
            });
          })
          .catch(() => this._utilService.showSWALError({ text: "ERROR_CAUSAL_REMOVE" }));
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async addCausal() {
    if (!this._authenticationService.hasCapability("create_causal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: ICausal = {
      name: this.causal.name.trim(),
      other: {
        code: this.causal.other.code,
      },
    };

    this._utilService.showLoading();
    await this._listService
      .create(data, "causal")
      .then(() => {
        this.loadCausal();
        this.causalFilter();
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_CAUSAL" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CAUSAL_INSERT" });
      });
  }

  async editCausal() {
    if (!this._authenticationService.hasCapability("edit_causal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const data: ICausal = {
      name: this.causal.name.trim(),
      other: {
        code: this.causal.other.code,
      },
    };

    this._utilService.showLoading();
    await this._listService
      .update(this.causal.id, data, "causal")
      .then(() => {
        this.loadCausal();
        this.causalFilter();
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_CAUSAL" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CAUSAL_EDIT" });
      });
  }
}
